import { Reducer } from 'redux';
import { AuthState, AuthActionTypes } from './types';
import { PASSWORD_FAILURE_MSG } from '../../utilities/constants';

const initialState: AuthState = {
  student_number: '',
  email: '',
  password: '',
  terms: false,
  marketing: false,
  isAuthenticating: true,
  isLoggedIn: false,
  isCodeSent: false,
  resetPasswordRequestSent: false,
  resetPasswordRequestError: '',
  resetPasswordWithCodeSent: false,
  resetPasswordRequestWithCodeError: '',
  changePasswordRequestSent: false,
  changePasswordResponseError: ''
};

const reducer: Reducer<AuthState> = (state = initialState, action) => {
  const fieldErrors = state.validation_errors
    ? state.validation_errors.map(({ field }) => {
        return field;
      })
    : [];
  switch (action.type) {
    case AuthActionTypes.CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        changePasswordRequestSent: true,
        changePasswordResponseError: ''
      };
    }
    case AuthActionTypes.CHANGE_PASSWORD_FAILURE: {
      return {
        ...state,
        changePasswordRequestSent: false,
        changePasswordResponseError: PASSWORD_FAILURE_MSG,
        server_errors: typeof action.payload === 'string' ? [action.payload] : undefined
      };
    }
    case AuthActionTypes.CHANGE_STUDENT_NUM:
      if (fieldErrors.includes('student_number')) {
        const i = fieldErrors.indexOf('student_number');
        return {
          ...state,
          student_number: action.payload,
          validation_errors: state
            .validation_errors!.slice(0, i)
            .concat(state.validation_errors!.slice(i + 1, state.validation_errors!.length))
        };
      } else {
        return { ...state, student_number: action.payload };
      }
    case AuthActionTypes.CHANGE_EMAIL:
      if (fieldErrors.includes('email')) {
        const i = fieldErrors.indexOf('email');
        return {
          ...state,
          email: action.payload,
          validation_errors: state
            .validation_errors!.slice(0, i)
            .concat(state.validation_errors!.slice(i + 1, state.validation_errors!.length))
        };
      } else {
        const validation_errors = [...(state.validation_errors || [])];
        if (action.payload.includes(' ')) {
          validation_errors.push({
            field: 'email',
            message: 'No spaces allowed'
          });
        }
        return { ...state, email: action.payload, validation_errors };
      }
    case AuthActionTypes.CHANGE_PASSWORD:
      if (fieldErrors.includes('password')) {
        const i = fieldErrors.indexOf('password');
        return {
          ...state,
          password: action.payload,
          validation_errors: state
            .validation_errors!.slice(0, i)
            .concat(state.validation_errors!.slice(i + 1, state.validation_errors!.length))
        };
      } else {
        return { ...state, password: action.payload };
      }

    case AuthActionTypes.CLICK_TERMS:
      if (fieldErrors.includes('terms')) {
        const i = fieldErrors.indexOf('terms');
        return {
          ...state,
          terms: !state.terms,
          validation_errors: state
            .validation_errors!.slice(0, i)
            .concat(state.validation_errors!.slice(i + 1, state.validation_errors!.length))
        };
      } else {
        return { ...state, terms: !state.terms };
      }
    case AuthActionTypes.CLICK_MARKETING:
      return { ...state, marketing: !state.marketing };
    case AuthActionTypes.COGNITO_LOGIN_REQUEST:
    case AuthActionTypes.COGNITO_REAUTH_REQUEST:
      return {
        ...state,
        isLoggedIn: false,
        isAuthenticating: true,
        validation_errors: undefined,
        server_errors: undefined
      };

    case AuthActionTypes.COGNITO_REAUTH_FAILURE:
      return {
        ...state,
        isLoggedIn: false,
        isAuthenticating: false
      };




    case AuthActionTypes.COGNITO_LOGIN_SUCCESS: {
      const { email, studentNo } = action.payload.sessionContext;

      return {
        ...state,
        isLoggedIn: true,
        isAuthenticating: false,
        student_number: studentNo,
        email: email,
        validation_errors: undefined,
        server_errors: undefined
      };
    }
    case AuthActionTypes.TEST_LOGIN_SUCCESS: {
      return {
        ...state,
        isTesting: true,
        isLoggedIn: true,
        isAuthenticating: false,
        student_number: '3',
        email: 'test@enroly.com',
        validation_errors: undefined,
        server_errors: undefined
      };
    }
    case AuthActionTypes.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        resetPasswordWithCodeSent: true
      };
    case AuthActionTypes.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        resetPasswordWithCodeSent: false,
        resetPasswordRequestWithCodeError: PASSWORD_FAILURE_MSG
      };
    default:
      return state;
  }
};

export { reducer as authReducer };
